"use strict";

var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));
var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _excluded = ["className"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultHeadCellStyles = function defaultHeadCellStyles(theme) {
  return {
    root: {},
    fixedHeader: {
      // position: 'sticky',
      top: '0px',
      zIndex: 100,
      backgroundColor: theme.palette.background.paper
    },
    firstIcon: {
      borderLeft: '1px solid #CFCFCC',
      paddingLeft: '1.5em'
    },
    lastIcon: {
      borderRight: '1px solid #CFCFCC'
    },
    tooltip: {
      cursor: 'pointer'
    },
    mypopper: {
      '&[data-x-out-of-boundaries]': {
        display: 'none'
      }
    },
    data: {
      display: 'inline-block'
    },
    sortAction: {
      display: 'flex',
      verticalAlign: 'top',
      cursor: 'pointer'
    },
    sortLabelRoot: {
      height: '10px'
    },
    sortActive: {
      color: theme.palette.text.primary
    },
    toolButton: {
      display: 'flex',
      outline: 'none',
      cursor: 'pointer'
    },
    hintIconAlone: {
      marginTop: '-3px',
      marginLeft: '3px'
    },
    hintIconWithSortIcon: {
      marginTop: '-3px'
    }
  };
};
var TableHeadCell = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableHeadCell, _react$default$Compon);
  function TableHeadCell() {
    var _this;
    _classCallCheck(this, TableHeadCell);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableHeadCell).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyboardSortinput", function (e) {
      if (e.key === 'Enter') {
        _this.props.toggleSort(_this.props.index);
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSortClick", function () {
      _this.props.toggleSort(_this.props.index);
    });
    return _this;
  }
  _createClass(TableHeadCell, [{
    key: "render",
    value: function render() {
      var _ref, _ref2;
      var _this$props = this.props,
        children = _this$props.children,
        classes = _this$props.classes,
        options = _this$props.options,
        sortDirection = _this$props.sortDirection,
        sort = _this$props.sort,
        hint = _this$props.hint,
        print = _this$props.print,
        firstIcon = _this$props.firstIcon,
        lastIcon = _this$props.lastIcon,
        column = _this$props.column,
        _this$props$cellHeade = _this$props.cellHeaderProps,
        cellHeaderProps = _this$props$cellHeade === void 0 ? {} : _this$props$cellHeade,
        _this$props$component = _this$props.components,
        components = _this$props$component === void 0 ? {} : _this$props$component;
      var className = cellHeaderProps.className,
        otherProps = _objectWithoutProperties(cellHeaderProps, _excluded);
      var Tooltip = components.Tooltip || _Tooltip.default;
      var sortActive = !!(sortDirection !== 'none' && sortDirection !== undefined);
      var ariaSortDirection = sortDirection === 'none' ? false : sortDirection;
      var sortLabelProps = _objectSpread({
        classes: {
          root: classes.sortLabelRoot
        },
        active: sortActive,
        hideSortIcon: true
      }, ariaSortDirection ? {
        direction: sortDirection
      } : {});
      var cellClass = (0, _classnames.default)((_ref = {}, _defineProperty2(_ref, classes.root, true), _defineProperty2(_ref, classes.firstIcon, firstIcon), _defineProperty2(_ref, classes.lastIcon, lastIcon), _defineProperty2(_ref, classes.fixedHeader, options.fixedHeader), _defineProperty2(_ref, 'datatables-noprint', !print), _defineProperty2(_ref, className, className), _ref));
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, _extends({
        className: cellClass,
        scope: "col",
        sortDirection: ariaSortDirection
      }, otherProps), options.sort && sort ? /*#__PURE__*/_react.default.createElement("span", {
        role: "button",
        onKeyUp: this.handleKeyboardSortinput,
        onClick: this.handleSortClick,
        className: classes.toolButton,
        "data-testid": "headcol-".concat(this.props.index),
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: options.textLabels.body.columnHeaderTooltip ? options.textLabels.body.columnHeaderTooltip(column) : options.textLabels.body.toolTip,
        placement: "bottom-start",
        classes: {
          tooltip: classes.tooltip,
          popper: classes.mypopper
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.sortAction
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)((_ref2 = {}, _defineProperty2(_ref2, classes.data, true), _defineProperty2(_ref2, classes.sortActive, sortActive), _ref2))
      }, children), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.sortAction
      }, /*#__PURE__*/_react.default.createElement(_TableSortLabel.default, sortLabelProps)))), hint && /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: hint
      }, /*#__PURE__*/_react.default.createElement(_Help.default, {
        className: !sortActive ? classes.hintIconAlone : classes.hintIconWithSortIcon,
        fontSize: "small"
      }))) : /*#__PURE__*/_react.default.createElement("div", {
        className: hint ? classes.sortAction : null
      }, children, hint && /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: hint,
        placement: "bottom-end",
        classes: {
          tooltip: classes.tooltip,
          popper: classes.mypopper
        },
        enterDelay: 300
      }, /*#__PURE__*/_react.default.createElement(_Help.default, {
        className: classes.hintIconAlone,
        fontSize: "small"
      }))));
    }
  }]);
  return TableHeadCell;
}(_react.default.Component);
_defineProperty(TableHeadCell, "propTypes", {
  /** Extend the style applied to components */
  classes: _propTypes.default.object,
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Current sort direction */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', 'none']),
  /** Callback to trigger column sort */
  toggleSort: _propTypes.default.func.isRequired,
  /** Sort enabled / disabled for this column * */
  sort: _propTypes.default.bool.isRequired,
  /** Hint tooltip text */
  hint: _propTypes.default.string,
  /** Column displayed in print */
  print: _propTypes.default.bool.isRequired,
  /** Optional to be used with `textLabels.body.columnHeaderTooltip` */
  column: _propTypes.default.object,
  /** Injectable component structure * */
  components: _propTypes.default.object
});
var _default = (0, _styles.withStyles)(defaultHeadCellStyles, {
  name: 'MUIDataTableHeadCell'
})(TableHeadCell);
exports.default = _default;